export default __webpack_public_path__ + "static/home_build_bg-0c9e59bf6a676575b3977519893efa93.svg";